(function(Drupal, $, once){
    Drupal.behaviors.mo27 = {
        attach() {
            // Use once() to ensure that events are only bound once per page load
            $(once('MO27', 'body')).first().each(function() {
                const menuPanels = {
                    MAIN_PANEL: 0,
                    SUB_PANEL1: 1,
                    SUB_PANEL2: 2
                };
                const totalPanels = Object.keys(menuPanels).length;
                const panelSlideTime = 500;
                const listLevelClass = '.MO27__list--level-';
                const linkClass = '.MO27__link';
                const listContainerClass = '.MO27__list-container--level-';
                const listScrollableContent = '.MO27__list-container__inner';
                const listOpenClass = 'MO27__list-container--open';
                const currentLevelAttr = 'data-current-level';
                const backButtonClass = '.MO27__back-button';
                const $component = $('.MO27');
                const $navContainer = $('.MO27__nav');


                $component.on('click', ".MO27__list-item--has-children " + linkClass, function(e) {
                    e.preventDefault();

                    // Level of clicked link
                    var linkLevel = parseInt($(this).closest('.MO27__list').attr('data-level'));
                    // Level of new panel
                    var newLinkLevel = linkLevel + 1;
                    // The HTML of the selected sub menu
                    var $subMenu = $(this).siblings('.MO27__sub-menu').first().clone(true).html();
                    // Title of new section
                    var sectionTitle = $(this).text();
                    // Is link already active
                    var isActive = $(this).hasClass('highlight');

                    if (isActive) {
                        $navContainer.attr(currentLevelAttr, linkLevel);

                        // Remove the active class.
                        $(this).removeClass('highlight');

                        // Iterate each all menu panels.
                        for (let i = 0; i < (totalPanels); i++) {
                            // If panels come after the old active link.
                            if (i >= linkLevel) {
                                // Give time to the animation to end and then hide.
                                setTimeout(function() {
                                    $(listContainerClass + (i+1) + ' ' + listScrollableContent, $component).hide();
                                }, panelSlideTime );
                            }
                        }
                    } else {
                        // Set the current level
                        $navContainer.attr(currentLevelAttr, newLinkLevel);

                        // Update the correct panel with the new sub menu content
                        $(listLevelClass + newLinkLevel, $component).html($subMenu);

                        // Remove the active class from the old link.
                        $(listLevelClass + linkLevel, $component).find('.MO27__link').removeClass('highlight');

                        // Update the section title with the text of the new link.
                        $(listContainerClass + newLinkLevel, $component).find('.MO27__section-title').text(sectionTitle);

                        // Show the panel content.
                        $(listContainerClass + newLinkLevel + ' ' + listScrollableContent , $component).show();

                        // Hide/Show the relevant section titles
                        $('.MO27__list-container', $component).removeClass(listOpenClass);
                        for (var i = 0; i < newLinkLevel; i++) {
                            $(listContainerClass + (i + 1), $component).addClass(listOpenClass);
                        }

                        $(listContainerClass + parseInt($(this).closest($navContainer).attr(currentLevelAttr))).find(linkClass).first().get(0).focus({ preventScroll: true });

                        // Update panel 2's back button text to the previous panel's title
                        if (newLinkLevel === menuPanels.SUB_PANEL2) {
                            var previousTitle = $(this).closest('.MO27__list-container').find('.MO27__section-title').text();
                            $(`${listContainerClass}2 ${backButtonClass}`, $component).text(previousTitle);
                        }

                        // Add the active class to the clicked link.
                        $(this).addClass('highlight');
                    }

                    $('.OR17__container').animate({scrollTop: 0});

                });

                $component.on('click', backButtonClass, function(e) {

                    var currLevel = parseInt($($navContainer).attr(currentLevelAttr));

                    $(linkClass, $component).removeClass('highlight');
                    // Decrement current level attribute to navigate back
                    $navContainer.attr(currentLevelAttr, currLevel - 1);
                    setTimeout(() => {
                        // Clear old link container so it doesn't occupy vertical space
                        $(listLevelClass + currLevel, $component).empty();
                    }, panelSlideTime);
                });

                // Hide for accessibility.
                $('.OR17__container').addClass('hide');

                $('.OR17__close-button').click(function() {
                    setTimeout(() => {
                        // Reset the menu on close
                        $(linkClass, $component).removeClass('highlight');
                        $(listScrollableContent).hide();
                        $('.MO27__list').hide();
                        $('.OR17__container').addClass('hide');
                        $navContainer.attr(currentLevelAttr, 0);
                    }, panelSlideTime);
                });

                $('.MO19__burger-menu').click(function() {
                    $('.MO27__list').show();
                    $('.OR17__container').removeClass('hide');
                });
            });
        }
    };

    Drupal.behaviors.scrollbar = {
        attach() {
            const target = '.MO27 .scrollbar-macosx';
            const $scroll_indicator = $(once('scrollbar', '.MO27')).find('.MO33');

            // Implements the jquery_scrollbar library for mac style scrollbar.
            $(once('scrollbar', target)).scrollbar({
                "onScroll": function(y, x){
                    const $arrow = $(this.wrapper).find('.MO33');

                    if (y.scroll == Math.round(y.maxScroll)){
                        $arrow.hide();
                    } else {
                        $arrow.show();
                    }
                }
            });

            // Add scroll indicator where it's scrollable.
            $(once('scrollbar',$scroll_indicator)).clone().appendTo(target);
        }
    };
})(Drupal, jQuery, once);
